import { AxiosInstance } from 'axios';
import { AbsentUseKindRepository } from '@/model/repository/manager/absentUseKind/AbsentUseKindRepository';

export default (Repository: AxiosInstance) =>
  (resource: string): AbsentUseKindRepository => ({
    index(payload) {
      return Repository.get(`${resource}`, { params: payload });
    },
  });
